import { O365MailWebController } from '../controller/O365MailWebController';
import { SensorType } from '../../types/sensor-type';
import { BaseSensorWebComponent } from '../../base/BaseSensorWebComponent';

export class O365MailWebComponent extends BaseSensorWebComponent {
  public controller!: O365MailWebController;

  constructor() {
    super();
    this.sensorType = SensorType.O365_MAIL;
    this.initialSetup({
      controllerConstructor: O365MailWebController,
    });
  }
}
